<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/messages/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";
import AssetableTable from "@/pages/components/assets/AssetableTable.vue";

export default {
  mixins: [UpdateForm],
  components: {App, Form, AssetableTable},
  props: ['message_id', 'assetableTableConfig'],
  data() {
    return {
      formRoute: route('api.v1.knowledge_base.messages.update', {message: this.message_id}),
      redirectRoute: route('knowledge_base.messages.index'),
    }
  },
  methods: {
    afterSuccess(form, response) {
      this.getMessage();
    },

    getMessage() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.knowledge_base.messages.show', {'message': this.message_id}),
        success: (response) => {
          this.$refs.form.setMessage(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getMessage();
  }
}
</script>

<template>
  <App title="Bericht bewerken">
    <form id="messageForm" @submit.prevent="submit">
      <Form ref="form">

        <template #widgets>
          <AssetableTable
              v-if="assetableTableConfig"
              :table-config="assetableTableConfig"
              :assetable-id="this.message_id"
              assetable-type="message"
              assetable-group="images"
              title="Afbeeldingen"
              id="messageimages"
          ></AssetableTable>
        </template>
      </Form>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="messageForm"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>